<div class="faq-autopay">
  <div class="faq-sub-question-title">Autopay questions</div>
    <section [multiple]="false" class="fs-16">
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link border-bottom no-padding-left" (click)="closeNonActiveCollapse('one')" mdbRipple [class.active]="accordianWithMDB.one">
          <div class="d-flex justify-content-between">
            <div>What payment methods can I use for autopay? </div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.one" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.one" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16" #one [class.fake-accourdian]="!accordianWithMDB.one">
          <div class="answ-block">
            You have a few options when it comes to setting up autopay, but there are some payment methods that aren’t available.   
          </div><br>
          <div class="answ-block no-padding-top">
            <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
              <li>You can use ACH payments by providing your bank’s routing number and your account number.</li>            
              <li>At this time, we’re not able to accept American Express, Chime, or Cash App for ACH payments.</li>
            </ul>     
          </div>
        </div>
      </div>  

      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('two')" mdbRipple [class.active]="accordianWithMDB.two">
          <div class="d-flex justify-content-between">
            <div>Can I stop an autopay deduction to make a manual payment?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.two" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.two" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16" #two [class.fake-accourdian]="!accordianWithMDB.two">
          <div class="answ-block">
            Yes, you can! If you need to stop an upcoming autopay deduction, just reach out to a Customer Service Representative at least two days before your scheduled draft date. Be sure to make your payment within five days of your due date to keep your policy active.   
          </div>
        </div>
      </div>

      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('four')" mdbRipple [class.active]="accordianWithMDB.four">
          <div class="d-flex justify-content-between">
            <div>What happens if my policy changes?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.four" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.four" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #four [class.fake-accourdian]="!accordianWithMDB.four">
          <div class="answ-block">
            If your premium changes, we’ll send you an updated autopay statement so you always know the new amount that will be deducted.
          </div>
        </div>
      </div>
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('five')" mdbRipple [class.active]="accordianWithMDB.five">
          <div class="d-flex justify-content-between">
            <div>Do I need to fill out a new autopay authorization form every year?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.five" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.five" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #five [class.fake-accourdian]="!accordianWithMDB.five">
          <div class="answ-block">
            No. If your banking information remains the same, your current authorization stays in place.
          </div>
        </div>
      </div>
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('six')" mdbRipple [class.active]="accordianWithMDB.six">
          <div class="d-flex justify-content-between">
            <div>Why choose autopay?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.six" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.six" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #six [class.fake-accourdian]="!accordianWithMDB.six">
          <div class="answ-block">
            Autopay is all about making life easier. When you enroll, you’ll enjoy:
          </div><br>
          <div class="answ-block no-padding-top">
            <ul class="no-margin-bottom padding-left pl16 faq-ul ml12">
              <li>Our lowest installment fee plan.</li>
              <li>Automatic payments so you never have to worry about missing a due date.</li>
              <li>Easy options to add, remove, or update autopay anytime during your policy term.</li>
              <li>Simple access and management through your Mapfre customer account.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('seven')" mdbRipple [class.active]="accordianWithMDB.seven">
          <div class="d-flex justify-content-between">
            <div>What pay plans are eligible for autopay?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.seven" alt="simple down arrow" />
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.seven" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #seven [class.fake-accourdian]="!accordianWithMDB.seven">
          <div class="answ-block">
            All pay plans are eligible for autopay.
          </div>
        </div>
      </div>
      <div class="padding-vertical pv16 faq-border-bottom">
        <a  class="mapfre link collapse-link no-padding-left" (click)=" closeNonActiveCollapse('eight')" mdbRipple [class.active]="accordianWithMDB.eight">
          <div class="d-flex justify-content-between">
            <div>What if I don’t have enough funds in my account?</div>
            <div class="img-block">
              <img src="assets/img/images/icon-simple-arrow-down.svg" *ngIf="!accordianWithMDB.eight" alt="simple down arrow"/>
              <img src="assets/img/images/icon-simple-arrow-up.svg" *ngIf="accordianWithMDB.eight" alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="collapse-content fs-16 dm-sans-medium padding-left pl16"  #eight [class.fake-accourdian]="!accordianWithMDB.eight">
          <div class="answ-block">
            If there aren’t enough funds in your account, we’ll pause the autopay attempts and send you a notice with the amount you need to pay to keep your policy active. Once you make a manual payment for the past-due amount, your autopay will pick up right where it left off.
          </div>
        </div>
      </div>  
    </section>                
  <div class="row margin-top mt24 text-center">
    <div class="col">
      <a (click)="onClickBack()" class="faq-back"><img src="assets/img/images/faq-icon-strong-arrow-left.svg" class="align-middle pr-1 edit-address"><p class="faq-back-btn edit-address">{{ 'BACK' | translate }}</p></a>
    </div>
  </div>
</div>